export const tr = {
    no: 'Hayır ',
    yes: 'Evet'
};
